export default {
  filters: 'Фильтры',
  resetFilters: 'Очистить фильтры',
};
